import React from 'react';
import { Box, Typography, Paper, Theme, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Person } from '@mui/icons-material';
import Colors from '../../utils/color';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: Colors.white,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  },
  header: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  personIcon: {
    color: Colors.daintree,
    fontSize: '20px',
  },
  nameDisplay: {
    lineHeight: '1.57 !important',
    fontSize: `${theme.spacing(1.5)} !important`,
    fontWeight: 'bold !important',
    color: Colors.daintree,
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
  },
  separator: {
    backgroundColor: Colors.alto,
    height: '1px',
    margin: 0,
  },
  bottomSection: {
    backgroundColor: '#f5f5f5',
    minHeight: '10px',
  },
}));

interface CustomerNameProps {
  customerName: string;
}

const CustomerInfo: React.FC<CustomerNameProps> = ({ customerName }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.header}>
        <Person className={classes.personIcon} />
        <Typography className={classes.nameDisplay}>{customerName}</Typography>
      </Box>

      <Divider className={classes.separator} />

      <Box className={classes.bottomSection} />
    </>
  );
};

export default CustomerInfo;
